const CurrencyExchangeReducers = (state = [], action) => {
  switch (action.type) {
    case "storeCurrencyExchange":
      return action.payload;
    default:
      return state;
  }
};
export default CurrencyExchangeReducers;
